import { createContext } from "react"

export const UsuarioContext = createContext({
  usuario: null,
  setUsuario: (newusuario, cambios) => {},
  setFechaReporte: (nuevafecha) => {},
  agregarCohortesUsuario: (cohortes) => {},
})

export default UsuarioContext
